import * as Yup from "yup";
import { FormValidation } from "@/src/type/strapi/component/translate";
import { StringHelper } from "@/src/util";
import { KEYS } from "@/src/const";

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
//const countryCodeRegExp = /^\d+$/;

export const step1ValidationSchema = (validation: FormValidation | undefined) =>
  Yup.object().shape({
    firstName: Yup.string().required(validation?.firstNameRequired).min(2, validation?.firstNameRequired).max(255, validation?.firstNameTooLong),
    lastName: Yup.string().required(validation?.lastNameRequired).min(2, validation?.lastNameRequired).max(255, validation?.lastNameTooLong),
    email: Yup.string().email(validation?.emailMustBeValid).max(255, validation?.emailTooLong).required(validation?.emailRequired),
    countryCode: Yup.number()
      .min(1, validation?.countryCodeMustBeValid)
      .max(998, validation?.countryCodeMustBeValid)
      .required(validation?.countryCodeRequired)
      .typeError(validation?.countryCodeMustBeValid ?? "Country code must be a number"),
    phoneNumber: Yup.string().matches(phoneRegExp, validation?.phoneNumberMustBeValid).required(validation?.phoneNumberRequired),
    whatsApp: Yup.string().min(8, validation?.whatsAppMustBeValid).max(13, validation?.whatsAppMustBeValid).nullable(),
  });

export const step2ValidationSchema = (validation: FormValidation | undefined) =>
  Yup.object().shape({
    bio: Yup.string().required(validation?.yourBioRequired).min(20, validation?.yourBioTooShort).max(4000, validation?.yourBioTooLong),
  });

export const step3ValidationSchema = (validation: FormValidation | undefined) =>
  Yup.object().shape({
    agentRelationship: Yup.string()
      .required(validation?.agentRelationshipRequired)
      .min(4, validation?.agentRelationshipRequired)
      .max(255, validation?.agentRelationshipRequired),
    brokerageName: Yup.string()
      .required(validation?.brokerageNameRequired)
      .min(2, validation?.brokerageNameRequired)
      .max(255, validation?.brokerageNameTooLong),
    brokerageWebsite: Yup.string().max(1000, validation?.brokerageWebsiteTooLong).url(validation?.brokerageWebsiteMustBeValid).nullable(),
    optionalLinkLabel: Yup.string().min(2, validation?.optionalLinkLabelTooShort).max(1000, validation?.optionalLinkLabelTooLong).nullable(),
    optionalLink: Yup.string().max(1000, validation?.optionalLinkTooLong).url(validation?.optionalLinkMustBeValid).nullable(),
  });

export function useBrokerProfileValidationSchema(validation: FormValidation | undefined) {
  return Yup.object().shape({
    ...step1ValidationSchema(validation).fields,
    ...step2ValidationSchema(validation).fields,
    ...step3ValidationSchema(validation).fields,
  });
}

export function checkQueryObjectHasProfile(searchParams?: Record<string, string | string[] | undefined>) {
  return StringHelper.checkIsStringOrIsNull(searchParams?.[KEYS.SEARCH_PARAM.BROKER_PROFILE], "::") !== "::";
}

export function checkQueryStringHasProfile(searchParams?: string) {
  return (searchParams ?? "").includes(`${KEYS.SEARCH_PARAM.BROKER_PROFILE}=`);
}
